import { formatTsObject } from './format-ts-object.js'
export function formatTsValue(value: unknown, indent = 0): string {
  if (Array.isArray(value)) {
    if (value.length === 0) return '[]'
    if (value.every((item) => item === null || typeof item !== 'object')) {
      return `[${value.map((item) => formatTsValue(item, indent)).join(', ')}]`
    }

    const childIndent = ' '.repeat(indent + 2)
    const currentIndent = ' '.repeat(indent)
    return `[\n${value.map((item) => `${childIndent}${formatTsValue(item, indent + 2)}`).join(',\n')}\n${currentIndent}]`
  }

  if (value && typeof value === 'object') {
    return formatTsObject(value as Record<string, unknown>, indent)
  }

  return JSON.stringify(value)
}
